export const isImageQuestion = (choices: any[]): boolean => {
  return choices.map(choice => choice.image != null && choice.image.length > 0).some(isImage => isImage)
}

export const buildUrl = (path: string): string => `http://${location.origin}${path}`
export const buildAdminUrl = (path: string): string => `${process.env.ADMIN_DOMAIN}${path}`
export const buildOtherUrl = (path: string): string => `${process.env.OTHER_DOMAIN}${path}`
export const buildJoinUrl = (path: string): string => `${process.env.JOIN_DOMAIN}${path}`

export const getParams = (): { [key: string]: any } => {
  const result: { [key: string]: any } = {}
  const strParams = window.location.search.substring(1).split('&')
  strParams.forEach(param => {
    const item = param.split('=')
    result[item[0]] = item[1]
  })
  return result
}

export const buildJoinQueryString = (data: any): string => {
  const { share_param } = data
  const query = `share_param=${share_param}`
  return query
}

interface LocalStorageInterface {
  expire?: number
  value: any
}

export const setStorage = (key: string, value: any, expireSec?: number) => {
  let data: LocalStorageInterface = { value }
  if (expireSec !== undefined) {
    // 期限が切れる時間をUNIX TIMEで記録
    const expire: number = Date.now() + expireSec * 1000
    data = {
      expire,
      value
    }
  }
  localStorage.setItem(key, JSON.stringify(data))
}

export const getStorage = (key: string): any | null => {
  const item = localStorage.getItem(key)

  if (item) {
    try {
      const obj: LocalStorageInterface = JSON.parse(item)

      // 期限が設定されていない or 期限内の場合
      if (!obj.expire || obj.expire > Date.now()) {
        return obj.value
      }

      localStorage.removeItem(key)
    } catch {
      // Jsonのパースに失敗した場合、単純なstring
      return item
    }
  }
  return null
}

export const removeStorage = (key: string) => {
  localStorage.removeItem(key)
}

export const flatten = (input: any[]): any[] => {
  const lambda = (a: any, b: any) => {
    return Array.isArray(b) ? a.concat(flatten(b)) : a.concat(b)
  }
  return input.reduce(lambda, [])
}
